/**
 * @generated SignedSource<<f109fd5075cca04c3995c67628a8faf6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedIconBubbleEmail_item$data = {
  readonly firstPhotoWebPath: string | null;
  readonly serviceId: string | null;
  readonly skus: ReadonlyArray<{
    readonly firstPhotoWebPath: string | null;
    readonly serviceId: string | null;
  } | null> | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSendToFriendModalLazy_item">;
  readonly " $fragmentType": "PdpSharedIconBubbleEmail_item";
};
export type PdpSharedIconBubbleEmail_item$key = {
  readonly " $data"?: PdpSharedIconBubbleEmail_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedIconBubbleEmail_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "small"
    }
  ],
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"small\")"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedIconBubbleEmail_item",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "skus",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSendToFriendModalLazy_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "cc801f0a2189a54c9174672865ce994e";

export default node;
